import { grey, red } from "@mui/material/colors";

const styles = {
  activeButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  circularProgress: {
    color: "white",
  },
  dialog: {
    borderRadius: "16px",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
  },
  subtitle: {
    textAlign: "center",
    color: grey[800],
    marginBottom: 20,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "end",
    width: "100%",
    padding: 0,
    marginTop: 36,
    gap: 12,
  },
  rulesContainer: {
    paddingTop: "20px",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ruleContainer: {
    width: '340px',
    display: "flex",
    alignItems: 'center'
  },
  errorRuleIcon: {
    color: "#DB463C",
    paddingRight: 8,
  },
  successRuleIcon: {
    color: "#53CA98",
    paddingRight: 8,
  }
};

export default styles;
